import isEmpty from "lodash.isempty";
import moment from "moment";
import { PRINT_TASK_NAMES } from "../consts/taskTypes";

const PDF_DPI = 2.83;
const WELCOME_ROW_HEIGHT = 10;
const FLIGHT_ROW_HEIGHT = 18;
const WELCOME_AREA_MM = 60;
const FLIGHT_AREA_MM = 115;
export const PRINT_COLORS = {
   BLACK: "#000",
   BLUE: "#00aeef",
   DARK_BLUE: "#0154a6"
};

export const calculatePdfData = (type, data) => {
   switch (type) {
      case "flight":
         return calculateFlightPdf(data);
      case "welcome":
         return calculateWelcomePdf(data);
      default:
         throw new Error("Wrong pdf type!");
   }
};

export const sortByFullDate = (a, b) => {
   const [aYear, aMonth, aDay] = a.data.split("-");
   const [bYear, bMonth, bDay] = b.data.split("-");
   const aTime = a.godzina || a.godzinaOd;
   const bTime = b.godzina || b.godzinaOd;
   const [aHour, aMinute] = aTime.split(":");
   const [bHour, bMinute] = bTime.split(":");
   const timeA = moment().set({
      year: aYear,
      month: aMonth,
      day: aDay,
      hour: aHour,
      minutes: aMinute
   });
   const timeB = moment().set({
      year: bYear,
      month: bMonth,
      day: bDay,
      hour: bHour,
      minutes: bMinute
   });
   return timeA.diff(timeB);
};

const sortFlightByDate = (a, b) => {
   const [aYear, aMonth, aDay] = a.dataZbiorki.split("-");
   const [bYear, bMonth, bDay] = b.dataZbiorki.split("-");
   const aTime = a.godzinaZbiorki;
   const bTime = b.godzinaZbiorki;
   const [aHour, aMinute] = aTime.split(":");
   const [bHour, bMinute] = bTime.split(":");
   const timeA = moment().set({
      year: aYear,
      month: aMonth,
      day: aDay,
      hour: aHour,
      minutes: aMinute
   });
   const timeB = moment().set({
      year: bYear,
      month: bMonth,
      day: bDay,
      hour: bHour,
      minutes: bMinute
   });
   return timeA.diff(timeB);
}

const calculateFlightPdf = (data) => {
   const pagesData = [{ comment: "", tables: [] }];
   const elementScaffold = document.getElementById("print-scaffold");
   let pageNumber = 0;
   let actualHeight = 0;

   const sortedData = data.tabela.sort((a, b) => {
      return sortFlightByDate(a, b);
   });

   sortedData.forEach((transfer) => {
      let tempHeight = FLIGHT_ROW_HEIGHT;
      if (!isEmpty(transfer.uwagiZbiorki)) {
         setElement(elementScaffold, transfer.uwagiZbiorki);
         tempHeight += elementScaffold.offsetHeight / PDF_DPI;
      }
      if (actualHeight + tempHeight > FLIGHT_AREA_MM) {
         pageNumber += 1;
         actualHeight = 0;
         pagesData.push({ comment: "", tables: [] });
      }
      actualHeight += tempHeight;
      pagesData[pageNumber].tables.push(transfer);
   });

   if (!isEmpty(data.zapisaneInformacje)) {
      setElement(elementScaffold, data.zapisaneInformacje);
      const bottomCommentHeight = elementScaffold.offsetHeight / PDF_DPI;
      if (actualHeight + bottomCommentHeight < FLIGHT_AREA_MM) {
         pagesData[pageNumber].comment = data.zapisaneInformacje;
      } else {
         pageNumber += 1;
         pagesData.push({ comment: data.zapisaneInformacje, tables: [] });
      }
   }

   return pagesData;
};

const calculateWelcomePdf = (data) => {
   const pagesData = [{ comment: "", tables: [] }];
   let pageNumber = 0;
   let actualHeight = 0;

   const elementScaffold = document.getElementById("print-scaffold");
   setElement(elementScaffold, data.uwagi);
   pagesData[pageNumber].comment = data.uwagi;
   actualHeight += elementScaffold.offsetHeight / PDF_DPI;
   const groupedTasks = new Map()
   data.zadania.forEach((task) => {
      if (!groupedTasks.has(task.data)) {
         groupedTasks.set(task.data, [task])
      } else {
         groupedTasks.set(task.data, [...groupedTasks.get(task.data), task])
      }
   });
   groupedTasks.forEach((val, key) => {
         groupedTasks.set(key, val.sort((a, b) => {
            return sortByFullDate(a, b);
         })
      )
      }
   )

   groupedTasks.forEach((val) => {
      val.forEach((task) => {
         if (actualHeight + WELCOME_ROW_HEIGHT >= WELCOME_AREA_MM) {
            pageNumber += 1;
            actualHeight = 0;
            pagesData.push({ comment: "", tables: [] });
         }
         actualHeight += WELCOME_ROW_HEIGHT;
         switch (task.nazwa) {
            case PRINT_TASK_NAMES.SPOTKANIE_INFORMACYJNE:
               return pagesData[pageNumber].tables.push({
                  type: "meeting",
                  name: task.nazwa,
                  data: {
                     date: task.data,
                     time: task.godzina,
                     place: task.miejsce
                  }
               });
            case PRINT_TASK_NAMES.WIZYTA_HOTELOWA:
               return pagesData[pageNumber].tables.push({
                  type: "visit",
                  name: task.nazwa,
                  data: {
                     date: task.data,
                     timeFrom: task.godzinaOd,
                     timeTo: task.godzinaDo,
                     place: task.miejsce
                  }
               });
            case PRINT_TASK_NAMES.DYZUR_TELEFONICZNY:
               return pagesData[pageNumber].tables.push({
                  type: "phone",
                  name: task.nazwa,
                  data: {
                     date: task.data,
                     timeFrom: task.godzinaOd,
                     timeTo: task.godzinaDo
                  }
               });
            default:
               console.log(`defaultCase`);
         }
      })
   });

   return pagesData;
};

const setElement = (element, data) => {
   element.textContent = data;
};
